module.exports = __webpack_public_path__ + "assets/img/smartTV3-icon3.b0eb8ae2.svg";